export default {
  en: {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'McDelivery Analysis',
    'all-vendors': 'All Vendors',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transactions',
    'all-label': 'All',
    'vendors': 'Vendors',
    'delivery-vendors': 'Delivery Vendors',
    'sales-pct-change': 'Sales +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Avg Check +/- %',
    'combined-vendors': 'Combined Vendors',
    'by-vendor': 'By Vendor',
    'four-days-ago': '4 Days Ago',
    'grubhub-warning': 'Grubhub 3PO order accuracy data is not currently available',
    'delivery-data-warning': 'Reports receive 3PO McDelivery data 3 days after the business date at 5:45 PM CST. First day available in reports is 4 days prior',
    'mcdelivery-3po': 'MCDelivery 3PO',
    'mcdelivery-3po-analysis': 'McDelivery 3PO Analysis',
    'vendor': 'Vendor',
    'delivery-transactions': 'Transactions',
    'total': 'Total',
    'by-date': 'By Date',
    'kiosk': 'Kiosk',
    'kiosk-cash': 'Kiosk Cash',
    'cash': 'Cash',
    'minutes-threshold': 'Minutes Threshold',
    'required': 'Required',
    'open-late-close-early': 'Open Late Close Early',
    'filter': 'Filter',
    'open-late-close-early-footer': 'This report uses the store settings from RFM and compares it against sales data to determine if the store may have opened late or closed early.',
    'open-late': 'Open Late',
    'close-early': 'Close Early',
    'sales-ledger-summary': 'Sales Ledger Summary',
    'sales-group': 'Sales Group',
    'sales-group-desc': 'Sales Groups are areas of the store (DT, Kiosk, etc) or Breakfast or Store Wide',
    'sales-groups': 'Sales Groups',
    'breakfast': 'Breakfast',
    'mobile-order-and-pay': 'Mobile Order & Pay',
    'all-net-sales': 'All Net Sales',
    'all-net-sales-desc': 'Storewide All Net Sales',
    'all-net-sales-comp-amt': 'All Net Sales +/-',
    'all-net-sales-comp-amt-desc': 'All Net Sales compared to last year (trading or calendar day)',
    'all-net-sales-comp-pct': 'All Net Sales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Storewide Guest Count',
    'gc-comp-amt-desc': 'Guest Count compared to last year',
    'gc-comp-pct-desc': '',
    'avg-check': 'Average Check',
    'avg-check-desc': 'Storewide All Net Sales divided by Storewide GC',
    'avg-check-comp-amt': 'Average Check +/-',
    'avg-check-comp-amt-desc': 'Average Check compared to last year',
    'avg-check-comp-pct': 'Average Check +/- %',
    'avg-check-comp-pct-desc': 'Average Check increase or decrease percent compared to last year ((This Year minus Last Year) divided by Last Year)',
    'all-net-sales-pct': '% of All Net Sales',
    'all-net-sales-pct-desc': 'All Net Sales for the specific group divided by Store Wide All Net Sales',
    'sum-all-dates': 'Sum all Dates',
    'sales-point-of-order': 'Sales Point of Order',
    'store-wide': 'Store Wide',
    'drive-thru': 'Drive Thru',
    'front-counter': 'Front Counter',
    'mcd-delivery': 'McDelivery',
    'in-store': 'In Store',
    'mop': 'MOP',
    'where-served': 'Where Served',
    'store-hours': 'Store Hours',
    'store-hours-info': 'Store Hours are gathered from your RFM settings',
    'day-sales': 'Day Sales',
    '7-day': '7 Day',
    '14-day': '14 Day',
    '21-day': '21 Day',
    '28-day': '28 Day',
    'wtd': 'WTD',
    'mtd': 'MTD',
    'ytd': 'YTD',
    'month-to-date': 'Month To Date',
    'year-to-date': 'Year To Date',
    'sales-detail': 'Sales Detail',
    'sales-ledger': 'Sales Ledger',
    'sales-ledger-analysis': 'Sales Ledger Analysis',
    'closing-hour': 'Closing Hour',
    'closing-time': 'Closing Time',
    'closing-time-description': 'Closing hour set by Org',
    'lobby-latest-time': 'Lobby Latest Time',
    'lobby-latest-time-description': 'Destination of Eatin, TakeOut, Delivery, Kiosk and Mobile TakeOut latest time a transaction was recorded',
    'dt-latest-time': 'DT Latest Time',
    'dt-latest-time-description': 'Destination of DriveThru and Mobile Drive Thru latest time a transaction was recorded',
    'lobby-gap': 'Lobby Gap',
    'lobby-gap-description': 'Lobby Latest Time - Closing Time',
    'dt-gap': 'DT Gap',
    'dt-gap-description': 'DT Latest Time - Closing Time',
    'qbo-daily-sales': 'QBO Daily Sales',
    'journal-no': 'Journal No',
    'journal-date': 'Journal Date',
    'delivery-trend': 'Delivery Trend',
    'select-store-prompt': 'Select a single store to view the delivery trend',
    'single-location-warning': 'This report uses only the first selected location. Please select a single store.',
    'biggest-changes': 'Biggest Changes',
    'todays-outliers': "Today's Outliers (Net Sales)",
    'five-week-avg': '5-Week Avg',
    'vs-last-5-weeks': 'vs Last 5 Weeks',
    'vs-5-week-avg': 'vs 5-Week Avg',
    'period': 'Period',
    'time-slice': 'Time Slice',
  },
  es: {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'Análisis de McDelivery',
    'all-vendors': 'Todos los Proveedores',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transacciones',
    'all-label': 'Todos',
    'vendors': 'Vendedores',
    'delivery-vendors': 'Vendedores de Entrega',
    'sales-pct-change': 'Ventas +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Cheque Prom +/- %',
    'combined-vendors': 'Proveedores Combinados',
    'by-vendor': 'Por Proveedor',
    'four-days-ago': 'Hace 4 días',
    'grubhub-warning': 'Los datos de precisión de pedidos de Grubhub 3PO no están disponibles actualmente',
    'delivery-data-warning': 'Los informes reciben datos de 3PO McDelivery 3 días después de la fecha comercial a las 5:45 PM CST. El primer día disponible en los informes es 4 días antes',
    'mcdelivery-3po': 'MCDelivery 3PO',
    'mcdelivery-3po-analysis': 'Análisis de McDelivery 3PO',
    'vendor': 'Vendedor',
    'delivery-transactions': 'Transacciones',
    'total': 'Total',
    'by-date': 'Por Fecha',
    'kiosk': 'Kiosco',
    'kiosk-cash': 'Kiosco Efectivo',
    'cash': 'Efectivo',
    'minutes-threshold': 'Umbral de Minutos',
    'required': 'Requerido',
    'open-late-close-early': 'Apertura Tarde Cierre Temprano',
    'filter': 'Filtro',
    'open-late-close-early-footer': 'Este informe utiliza la configuración de la tienda de RFM y la compara con los datos de ventas para determinar si la tienda pudo haber abierto tarde o cerrado temprano.',
    'open-late': 'Apertura Tarde',
    'close-early': 'Cierre Temprano',
    'sales-ledger-summary': 'Resumen del Libro de Ventas',
    'sales-group': 'Grupo de Ventas',
    'sales-group-desc': 'Los grupos de ventas son áreas de la tienda (DT, Kiosco, etc.) o Desayuno o Tienda Completa',
    'sales-groups': 'Grupos de Ventas',
    'breakfast': 'Desayuno',
    'mobile-order-and-pay': 'Pedido y Pago Móvil',
    'all-net-sales': 'Ventas Netas Totales',
    'all-net-sales-desc': 'Ventas Netas Totales de Toda la Tienda',
    'all-net-sales-comp-amt': 'Ventas Netas Totales +/-',
    'all-net-sales-comp-amt-desc': 'Ventas Netas Totales comparadas con el año pasado (día comercial o calendario)',
    'all-net-sales-comp-pct': 'Ventas Netas Totales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Conteo Total de Clientes de la Tienda',
    'gc-comp-amt-desc': 'Conteo de Clientes comparado con el año pasado',
    'gc-comp-pct-desc': '',
    'avg-check': 'Ticket Promedio',
    'avg-check-desc': 'Ventas Netas Totales de la Tienda divididas por el Conteo Total de Clientes de la Tienda',
    'avg-check-comp-amt': 'Ticket Promedio +/-',
    'avg-check-comp-amt-desc': 'Ticket Promedio comparado con el año pasado',
    'avg-check-comp-pct': 'Ticket Promedio +/- %',
    'avg-check-comp-pct-desc': 'Porcentaje de aumento o disminución del Ticket Promedio comparado con el año pasado ((Este año menos el año pasado) dividido por el año pasado)',
    'all-net-sales-pct': '% de Ventas Netas Totales',
    'all-net-sales-pct-desc': 'Ventas Netas Totales para el grupo específico divididas por las Ventas Netas Totales de la Tienda',
    'sum-all-dates': 'Sumar Todas las Fechas',
    'sales-point-of-order': 'Punto de Venta',
    'store-wide': 'Todo el Local',
    'drive-thru': 'Auto Servicio',
    'front-counter': 'Mostrador',
    'mcd-delivery': 'McDelivery',
    'in-store': 'En Tienda',
    'mop': 'MOP',
    'where-served': 'Dónde se sirvió',
    'store-hours': 'Horas de la Tienda',
    'store-hours-info': 'Las horas de la tienda se recopilan de la configuración de RFM.',
    'day-sales': 'Ventas Diarias',
    '7-day': '7 Días',
    '14-day': '14 Días',
    '21-day': '21 Días',
    '28-day': '28 Días',
    'wtd': 'SDF',
    'mtd': 'MDF',
    'ytd': 'ADF',
    'month-to-date': 'Mes Hasta la Fecha',
    'year-to-date': 'Año Hasta la Fecha',
    'sales-detail': 'Detalle de Ventas',
    'sales-ledger': 'Libro de Ventas',
    'sales-ledger-analysis': 'Análisis del Libro de Ventas',
    'closing-hour': 'Hora de Cierre',
    'closing-time': 'Hora de Cierre',
    'closing-time-description': 'Hora de cierre establecida por la organización',
    'lobby-latest-time': 'Última Hora del Lobby',
    'lobby-latest-time-description': 'Hora más reciente de una transacción registrada en los destinos: Comer en Local, Para Llevar, Entrega, Kiosco y Para Llevar Móvil',
    'dt-latest-time': 'Última Hora de Auto',
    'dt-latest-time-description': 'Hora más reciente de una transacción registrada en los destinos: Auto Servicio y Auto Servicio Móvil',
    'lobby-gap': 'Diferencia del Lobby',
    'lobby-gap-description': 'Última Hora del Lobby - Hora de Cierre',
    'dt-gap': 'Diferencia de Auto',
    'dt-gap-description': 'Última Hora de Auto - Hora de Cierre',
    'qbo-daily-sales': 'Ventas Diarias QBO',
    'journal-no': 'Número de Diario',
    'journal-date': 'Fecha del Diario',
    'delivery-trend': 'Tendencia de Entrega',
    'select-store-prompt': 'Seleccione una sola tienda para ver la tendencia de entrega',
    'single-location-warning': 'Este informe usa solo la primera ubicación seleccionada. Por favor seleccione una sola tienda.',
    'biggest-changes': 'Mayores Cambios',
    'todays-outliers': 'Valores Atípicos de Hoy (Ventas Netas)',
    'five-week-avg': 'Promedio de 5 Semanas',
    'vs-last-5-weeks': 'vs Últimas 5 Semanas',
    'vs-5-week-avg': 'vs Promedio de 5 Semanas',
    'period': 'Período',
    'time-slice': 'Segmento de Tiempo',
  },
  fr: {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'Analyse McDelivery',
    'all-vendors': 'Tous les prestataires',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transactions',
    'all-label': 'Tous',
    'vendors': 'Prestataires',
    'delivery-vendors': 'Prestataires de livraison',
    'sales-pct-change': 'Ventes +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Ticket moyen +/- %',
    'combined-vendors': 'Prestataires combinés',
    'by-vendor': 'Par prestataire',
    'four-days-ago': 'Il y a 4 jours',
    'grubhub-warning': 'Les données de précision des commandes Grubhub 3PO ne sont pas disponibles actuellement',
    'delivery-data-warning': 'Les rapports reçoivent les données McDelivery 3PO 3 jours après la date d’activité, à 17 h 45 CST. Le premier jour disponible dans les rapports remonte à 4 jours',
    'mcdelivery-3po': 'McDelivery 3PO',
    'mcdelivery-3po-analysis': 'Analyse McDelivery 3PO',
    'vendor': 'Prestataire',
    'delivery-transactions': 'Transactions',
    'total': 'Total',
    'by-date': 'Par date',
    'kiosk': 'Borne',
    'kiosk-cash': 'Espèces borne',
    'cash': 'Espèces',
    'minutes-threshold': 'Seuil en minutes',
    'required': 'Obligatoire',
    'open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'filter': 'Filtre',
    'open-late-close-early-footer': 'Ce rapport utilise les paramètres du restaurant définis dans RFM et les compare aux données de ventes pour déterminer si le restaurant a pu ouvrir en retard ou fermer en avance.',
    'open-late': 'Ouverture tardive',
    'close-early': 'Fermeture anticipée',
    'sales-ledger-summary': 'Synthèse du journal des ventes',
    'sales-group': 'Groupe de ventes',
    'sales-group-desc': 'Les groupes de ventes correspondent à des zones du restaurant (Drive, Borne, etc.), au petit-déjeuner ou à l’ensemble du restaurant',
    'sales-groups': 'Groupes de ventes',
    'breakfast': 'Petit-déjeuner',
    'mobile-order-and-pay': 'Commande et paiement mobiles',
    'all-net-sales': 'Ventes nettes totales',
    'all-net-sales-desc': 'Ventes nettes totales sur l’ensemble du restaurant',
    'all-net-sales-comp-amt': 'Ventes nettes totales +/-',
    'all-net-sales-comp-amt-desc': 'Ventes nettes totales comparées à l’an dernier (jour d’exploitation ou jour calendaire)',
    'all-net-sales-comp-pct': 'Ventes nettes totales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Nombre de clients sur l’ensemble du restaurant',
    'gc-comp-amt-desc': 'Nombre de clients comparé à l’an dernier',
    'gc-comp-pct-desc': '',
    'avg-check': 'Ticket moyen',
    'avg-check-desc': 'Ventes nettes totales du restaurant divisées par le nombre de clients du restaurant',
    'avg-check-comp-amt': 'Ticket moyen +/-',
    'avg-check-comp-amt-desc': 'Ticket moyen comparé à l’an dernier',
    'avg-check-comp-pct': 'Ticket moyen +/- %',
    'avg-check-comp-pct-desc': 'Pourcentage d’augmentation ou de diminution du ticket moyen par rapport à l’an dernier ((Cette année moins l’an dernier) divisé par l’an dernier)',
    'all-net-sales-pct': '% des ventes nettes totales',
    'all-net-sales-pct-desc': 'Ventes nettes totales du groupe concerné divisées par les ventes nettes totales de l’ensemble du restaurant',
    'sum-all-dates': 'Cumuler toutes les dates',
    'sales-point-of-order': 'Point de commande des ventes',
    'store-wide': 'Tout le restaurant',
    'drive-thru': 'Drive',
    'front-counter': 'Comptoir',
    'mcd-delivery': 'McDelivery',
    'in-store': 'En restaurant',
    'mop': 'MOP',
    'where-served': 'Lieu de service',
    'store-hours': 'Horaires du restaurant',
    'store-hours-info': 'Les horaires du restaurant proviennent de vos paramètres RFM',
    'day-sales': 'Ventes du jour',
    '7-day': '7 jours',
    '14-day': '14 jours',
    '21-day': '21 jours',
    '28-day': '28 jours',
    'wtd': 'CSJ',
    'mtd': 'CMJ',
    'ytd': 'CAJ',
    'month-to-date': 'Cumul du mois à ce jour',
    'year-to-date': 'Cumul de l’année à ce jour',
    'sales-detail': 'Détail des ventes',
    'sales-ledger': 'Journal des ventes',
    'sales-ledger-analysis': 'Analyse du journal des ventes',
    'closing-hour': 'Heure de fermeture',
    'closing-time': 'Heure de fermeture',
    'closing-time-description': 'Heure de fermeture définie par l’organisation',
    'lobby-latest-time': 'Dernière heure en salle',
    'lobby-latest-time-description': 'Heure la plus tardive à laquelle une transaction a été enregistrée pour les destinations Sur place, À emporter, Livraison, Borne et À emporter mobile',
    'dt-latest-time': 'Dernière heure au Drive',
    'dt-latest-time-description': 'Heure la plus tardive à laquelle une transaction a été enregistrée pour les destinations Drive et Drive mobile',
    'lobby-gap': 'Écart en salle',
    'lobby-gap-description': 'Dernière heure en salle - Heure de fermeture',
    'dt-gap': 'Écart au Drive',
    'dt-gap-description': 'Dernière heure au Drive - Heure de fermeture',
    'qbo-daily-sales': 'Ventes quotidiennes QBO',
    'journal-no': 'N° d’écriture',
    'journal-date': 'Date d’écriture',
  },
  'fr-ca': {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'Analyse McDelivery',
    'all-vendors': 'Tous les fournisseurs',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transactions',
    'all-label': 'Tous',
    'vendors': 'Fournisseurs',
    'delivery-vendors': 'Fournisseurs de livraison',
    'sales-pct-change': 'Ventes +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Facture moyenne +/- %',
    'combined-vendors': 'Fournisseurs combinés',
    'by-vendor': 'Par fournisseur',
    'four-days-ago': 'Il y a 4 jours',
    'grubhub-warning': 'Les données d’exactitude des commandes Grubhub 3PO ne sont pas disponibles pour le moment',
    'delivery-data-warning': 'Les rapports reçoivent les données McDelivery 3PO 3 jours après la date d’exploitation, à 17 h 45 HNC. Le premier jour disponible dans les rapports remonte à 4 jours',
    'mcdelivery-3po': 'McDelivery 3PO',
    'mcdelivery-3po-analysis': 'Analyse McDelivery 3PO',
    'vendor': 'Fournisseur',
    'delivery-transactions': 'Transactions',
    'total': 'Total',
    'by-date': 'Par date',
    'kiosk': 'Borne',
    'kiosk-cash': 'Comptant borne',
    'cash': 'Comptant',
    'minutes-threshold': 'Seuil en minutes',
    'required': 'Obligatoire',
    'open-late-close-early': 'Ouverture tardive et fermeture hâtive',
    'filter': 'Filtre',
    'open-late-close-early-footer': 'Ce rapport utilise les paramètres du restaurant définis dans RFM et les compare aux données de ventes afin de déterminer si le restaurant a pu ouvrir en retard ou fermer plus tôt.',
    'open-late': 'Ouverture tardive',
    'close-early': 'Fermeture hâtive',
    'sales-ledger-summary': 'Sommaire du grand livre des ventes',
    'sales-group': 'Groupe de ventes',
    'sales-group-desc': 'Les groupes de ventes correspondent à des secteurs du restaurant (SV, borne, etc.), au déjeuner ou à l’ensemble du restaurant',
    'sales-groups': 'Groupes de ventes',
    'breakfast': 'Déjeuner',
    'mobile-order-and-pay': 'Commande et paiement mobiles',
    'all-net-sales': 'Ventes nettes totales',
    'all-net-sales-desc': 'Ventes nettes totales pour l’ensemble du restaurant',
    'all-net-sales-comp-amt': 'Ventes nettes totales +/-',
    'all-net-sales-comp-amt-desc': 'Ventes nettes totales comparées à l’an dernier (jour d’exploitation ou jour civil)',
    'all-net-sales-comp-pct': 'Ventes nettes totales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Achalandage pour l’ensemble du restaurant',
    'gc-comp-amt-desc': 'Achalandage comparé à l’an dernier',
    'gc-comp-pct-desc': '',
    'avg-check': 'Facture moyenne',
    'avg-check-desc': 'Ventes nettes totales du restaurant divisées par l’achalandage du restaurant',
    'avg-check-comp-amt': 'Facture moyenne +/-',
    'avg-check-comp-amt-desc': 'Facture moyenne comparée à l’an dernier',
    'avg-check-comp-pct': 'Facture moyenne +/- %',
    'avg-check-comp-pct-desc': 'Pourcentage d’augmentation ou de diminution de la facture moyenne par rapport à l’an dernier ((Cette année moins l’an dernier) divisé par l’an dernier)',
    'all-net-sales-pct': '% des ventes nettes totales',
    'all-net-sales-pct-desc': 'Ventes nettes totales du groupe visé divisées par les ventes nettes totales de l’ensemble du restaurant',
    'sum-all-dates': 'Cumuler toutes les dates',
    'sales-point-of-order': 'Point de commande des ventes',
    'store-wide': 'Ensemble du restaurant',
    'drive-thru': 'Service au volant',
    'front-counter': 'Comptoir',
    'mcd-delivery': 'McDelivery',
    'in-store': 'En restaurant',
    'mop': 'MOP',
    'where-served': 'Lieu de service',
    'store-hours': 'Heures d’ouverture',
    'store-hours-info': 'Les heures d’ouverture proviennent de vos paramètres RFM',
    'day-sales': 'Ventes du jour',
    '7-day': '7 jours',
    '14-day': '14 jours',
    '21-day': '21 jours',
    '28-day': '28 jours',
    'wtd': 'CSJ',
    'mtd': 'CMJ',
    'ytd': 'CAJ',
    'month-to-date': 'Cumul du mois à ce jour',
    'year-to-date': 'Cumul de l’année à ce jour',
    'sales-detail': 'Détail des ventes',
    'sales-ledger': 'Grand livre des ventes',
    'sales-ledger-analysis': 'Analyse du grand livre des ventes',
    'closing-hour': 'Heure de fermeture',
    'closing-time': 'Heure de fermeture',
    'closing-time-description': 'Heure de fermeture définie par l’organisation',
    'lobby-latest-time': 'Dernière heure en salle à manger',
    'lobby-latest-time-description': 'Heure la plus tardive à laquelle une transaction a été enregistrée pour les destinations Sur place, Pour emporter, Livraison, Borne et Pour emporter mobile',
    'dt-latest-time': 'Dernière heure au service au volant',
    'dt-latest-time-description': 'Heure la plus tardive à laquelle une transaction a été enregistrée pour les destinations Service au volant et Service au volant mobile',
    'lobby-gap': 'Écart en salle à manger',
    'lobby-gap-description': 'Dernière heure en salle à manger - Heure de fermeture',
    'dt-gap': 'Écart au service au volant',
    'dt-gap-description': 'Dernière heure au service au volant - Heure de fermeture',
    'qbo-daily-sales': 'Ventes quotidiennes QBO',
    'journal-no': 'N° d’écriture',
    'journal-date': 'Date d’écriture',
  },
};
